module.exports = require("/tmp/build_e2a79956/src/lib/gatsby/gatsby-browser.tsx");